import { invoke } from '@shared/easyfy.decorators';
import { globalEvent } from '@shared/easyfy.core';

@invoke
export class DialogModal {
  onInit() {
    globalEvent({
      type: 'click',
      events: [
        {
          event: 'open-modal',
          callback: this.openModal,
        },
        {
          event: 'close-modal',
          callback: this.closeModal,
        },
      ],
    });
    globalEvent({
      type: 'form-success',
      events: [
        {
          event: 'close-modal-form',
          callback: this.closeModal,
        },
      ],
    });
  }

  openModal = (e: Event) => {
    e.preventDefault();
    const target = e.target;
    if (!(target instanceof HTMLElement)) return;

    const controlsId = target.getAttribute('data-dialog-id');
    const dialog = document.getElementById(controlsId ?? '');
    if (!(dialog instanceof HTMLDialogElement)) return;

    dialog.showModal();
    dialog.focus();

    dialog.addEventListener('close', () => target.focus(), { once: true });
  };

  closeModal = (e: Event) => {
    const target = e.target;
    if (!(target instanceof HTMLElement)) return;

    const dialog = target.closest('dialog');
    if (!(dialog instanceof HTMLDialogElement)) return;

    dialog.close();
  };
}
